<div class="help-section">
  <h3>{{ label }}</h3>
  <ng-content></ng-content>
</div>
<div>
  <button [disabled]="first" mat-button matStepperPrevious>Tillbaka</button>
  <button [disabled]="last" mat-button matStepperNext>Nästa</button>
  <button mat-button (click)="onClose()">Stäng</button>
</div>
